import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { MainTitle, SmallTitle } from "../../data/style/Style";

export const DescriptionText = ({ children, style }) => {
  return (
    <Typography
      sx={{
        fontFamily: "DM Sans, sans-serif",
        color: "#555",
        lineHeight: 1.6,
        ...style,
      }}
    >
      {children}
    </Typography>
  );
};

export const TwoTonedHeader = ({ mainText, subText, fontSize }) => {
  return (
    <h1
      style={{
        fontFamily: "Oswald, sans-serif",
        fontWeight: 900,
        fontSize: fontSize,
        lineHeight: 0.93,
        letterSpacing: "-0.01em",
        textTransform: "uppercase",
        marginBottom: 16,
        color: "#FFF",
        textAlign: "center",
      }}
    >
      {mainText}
      <br />
      <span
        style={{
          WebkitTextFillColor: "transparent",
          background: "linear-gradient(135deg,#f97316 20%,#fbbf24 80%)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
        }}
      >
        {subText}
      </span>
    </h1>
  );
};

export const CardTitle = ({ subTitle, mainTitle, isMobile, alt }) => {
  return (
    <Stack sx={{ marginBottom: 1 }}>
      {alt ? (
        <>
          <MainTitle fontSize={isMobile ? "0.8rem" : "1rem"}>
            {mainTitle}
          </MainTitle>
          <SmallTitle fontSize={"0.6rem"}>{subTitle}</SmallTitle>
        </>
      ) : (
        <>
          <SmallTitle fontSize={"0.6rem"}>{subTitle}</SmallTitle>
          <MainTitle fontSize={isMobile ? "0.8rem" : "1rem"}>
            {mainTitle}
          </MainTitle>
        </>
      )}
    </Stack>
  );
};
